import type { Database } from "@shared/database.types";
import { formatPhone, formatTime, formatTimestamp } from "../../lib";
import type { Tag } from "../_shared";

export type SchoolRow = Omit<
  Database["public"]["Views"]["v_schools_list"]["Row"],
  "admins"
> & {
  admins: Tag[] | null;
};

export const schoolsListSortMap: Record<string, string> = {
  name: "name",
  district: "district",
  city: "city",
  state: "state",
  zip: "zip",
  created_at: "created_at",
  updated_at: "updated_at",
};

export const schoolsSearchCols = [
  "name",
  "district",
  "city",
  "address_line1",
  "zip",
];

export function decorateSchool(school: SchoolRow) {
  const admins = school.admins ?? [];
  return {
    ...school,
    admin: admins[0]?.label ?? null,
    f_full_day_start: formatTime(school.full_day_start),
    f_morning_end: formatTime(school.morning_end),
    f_afternoon_start: formatTime(school.afternoon_start),
    f_full_day_end: formatTime(school.full_day_end),
    f_phone: formatPhone(school.phone),
    f_notification_emails: (school.notification_emails ?? []).join(", "),
    f_created_at: formatTimestamp(school.created_at),
    f_updated_at: formatTimestamp(school.updated_at),
    f_deleted_at: formatTimestamp(school.deleted_at),
  };
}
